import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "wc-order-type-cart-picker__title" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "wc-order-type-cart-picker__list" }
const _hoisted_5 = { class: "wc-order-type-cart-picker__reassure" }

import { computed } from 'vue';
import WCModal from '@/modules/modals/components/WCModal/WCModal.vue';
import WCModalHeader from '@/modules/modals/components/WCModalHeader/WCModalHeader.vue';
import WCModalBody from '@/modules/modals/components/WCModalBody/WCModalBody.vue';
import WCOrderTypeCartOption from '@/modules/orderTypes/components/WCOrderTypeCartOption/WCOrderTypeCartOption.vue';
import useOrderTypes from '@/composables/useOrderTypes';
import ItemSummary from '@/models/entities/items/item-summary';
import OrderType from '@/models/entities/cart/order-type';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCOrderTypeCartPicker',
  props: {
    close: { type: Function },
    dismiss: { type: Function },
    item: {},
    orderTypes: {},
    variation: {}
  },
  setup(__props: any) {

const props = __props;

const { activeOrderType } = useOrderTypes();

const currentOrderTypeIsEligible = computed(() =>
  props.orderTypes.some(orderType => orderType.id === activeOrderType.value?.id),
);

const isSingleDestination = computed(
  () => !currentOrderTypeIsEligible.value && props.orderTypes.length === 1,
);

const titleKey = computed(() =>
  isSingleDestination.value ? 'addToOrderTypeCart' : 'addToWhichOrder',
);

const titleParams = computed(() =>
  isSingleDestination.value ? { orderTypeName: props.orderTypes[0]?.name ?? '' } : {},
);

const contextKey = computed(() =>
  currentOrderTypeIsEligible.value
    ? 'itemAvailableInMultipleCarts'
    : 'itemNotAvailableInCurrentCart',
);

const contextParams = computed(() =>
  currentOrderTypeIsEligible.value
    ? { itemName: props.item.name }
    : { orderTypeName: activeOrderType.value?.name ?? '' },
);

const onClose = (): void => props.dismiss();

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(WCModal, {
    position: "center",
    class: "wc-order-type-cart-picker",
    onDismiss: onClose
  }, {
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "wc-order-type-cart-picker__handle",
        "aria-hidden": "true"
      }, [
        _createElementVNode("span", { class: "wc-order-type-cart-picker__handle-bar" })
      ], -1)),
      _cache[3] || (_cache[3] = _createTextVNode()),
      _createVNode(WCModalHeader, { class: "wc-order-type-cart-picker__header" }, {
        default: _withCtx(() => [
          _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t(titleKey.value, titleParams.value)), 1),
          _cache[0] || (_cache[0] = _createTextVNode()),
          _createElementVNode("button", {
            type: "button",
            class: "wc-order-type-cart-picker__close",
            "aria-label": _ctx.$t('close'),
            onClick: onClose
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'xmark'],
              "aria-hidden": "true"
            })
          ], 8, _hoisted_2)
        ]),
        _: 1
      }),
      _cache[4] || (_cache[4] = _createTextVNode()),
      _createElementVNode("p", {
        class: "wc-order-type-cart-picker__item-name",
        innerHTML: _ctx.$t(contextKey.value, contextParams.value)
      }, null, 8, _hoisted_3),
      _cache[5] || (_cache[5] = _createTextVNode()),
      _createVNode(WCModalBody, { class: "wc-order-type-cart-picker__body" }, {
        default: _withCtx(() => [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderTypes, (orderType) => {
              return (_openBlock(), _createBlock(WCOrderTypeCartOption, {
                key: orderType.id,
                item: _ctx.item,
                orderType: orderType,
                variation: _ctx.variation
              }, null, 8, ["item", "orderType", "variation"]))
            }), 128))
          ]),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createElementVNode("p", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'shield-halved'],
              "aria-hidden": "true"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('orderTypeCartStaysUntouched', { orderTypeName: _unref(activeOrderType)?.name ?? '' })), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})